import ManageUsers from '@src/main/ui/components/ManageUsers/ManageUsers';
import { type FC } from 'react';

const ManageUsersPage: FC = () => <ManageUsers />;

export default ManageUsersPage;
